import * as React from 'react'
import { browserHistory } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Routes } from '../../../constants/Routes'
import { UberEatsStore } from '../../../stores/UberEatsStore'
import { UberEatsDenyReasonPicker } from '../../../components/UberEatsIncoming/UberEatsDenyReasonPicker'
import { UberEatsIncomingOrderBarView } from '../../../components/UberEatsIncoming/UberEatsIncomingOrderBarView'

interface Props {
  uberEatsStore?: UberEatsStore
}

const isOnRegister = () => window.location.pathname.replace(/\/$/, '') === Routes.POS_SALE()

@inject('uberEatsStore')
@observer
export class UberEatsIncomingOrderBar extends React.Component<Props> {
  componentDidMount() {
    document.addEventListener('click', this.primeSoundOnFirstClick, true)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.primeSoundOnFirstClick, true)
  }

  primeSoundOnFirstClick = async () => {
    const store = this.props.uberEatsStore!
    if (!store.isAlertDevice) return

    if (await store.primeSound()) {
      document.removeEventListener('click', this.primeSoundOnFirstClick, true)
    }
  }

  viewOrder = () => {
    this.props.uberEatsStore!.requestOpenIncomingTab()
    if (!isOnRegister()) browserHistory.push(Routes.POS_SALE())
  }

  render() {
    const store = this.props.uberEatsStore!
    const entry = store.topOrder
    if (!store.shouldShowAlertBar || !entry) return null

    const { order, status, failedAction, errorMessage, denyDraft } = entry
    const { stage, label } = store.getUrgency(entry)
    const isFailed = status === 'failed'

    return (
      <UberEatsIncomingOrderBarView
        order={order}
        stage={status === 'expired' ? 'expired' : stage}
        timeLabel={label}
        waitingCount={store.moreWaitingCount}
        isInFlight={status === 'accepting' || status === 'denying'}
        isAccepting={status === 'accepting'}
        acceptError={isFailed && failedAction === 'accept' ? errorMessage : undefined}
        denyError={isFailed && failedAction === 'deny' ? errorMessage : undefined}
        soundBlocked={store.soundBlocked}
        denyPicker={
          denyDraft && (
            <UberEatsDenyReasonPicker
              reasonCode={denyDraft.reasonCode}
              explanation={denyDraft.explanation}
              isInFlight={status === 'accepting' || status === 'denying'}
              isDenying={status === 'denying'}
              onSelectReason={(code) => store.setDenyReason(order.id, code)}
              onChangeExplanation={(text) => store.setDenyExplanation(order.id, text)}
              onCancel={() => store.cancelDeny(order.id)}
              onConfirm={() => store.confirmDeny(order.id)}
            />
          )
        }
        onAccept={() => store.acceptOrder(order.id)}
        onDeny={() => store.startDeny(order.id)}
        onViewOrder={this.viewOrder}
        onDismiss={() => store.removeIncomingOrder(order.id)}
        onEnableSound={() => store.primeSound()}
      />
    )
  }
}
